module.exports = function (Utils, Konva) {
    'use strict';
    function scaleY(amplitude, height, scale) {
        var range = 256;
        var offset = 128;
        var scaledAmplitude = (amplitude * scale + offset) * height / range;
        return height - Utils.clamp(height - scaledAmplitude, 0, height);
    }
    function WaveformShape(options) {
        Konva.Shape.call(this, { fill: options.color });
        this._view = options.view;
        this._segment = options.segment;
        this.sceneFunc(this._sceneFunc);
    }
    WaveformShape.prototype = Object.create(Konva.Shape.prototype);
    WaveformShape.prototype.setWaveformColor = function (color) {
        this.fill(color);
    };
    WaveformShape.prototype._sceneFunc = function (context) {
        var frameOffset = this._view.getFrameOffset();
        var width = this._view.getWidth();
        var height = this._view.getHeight();
        this._drawWaveform(context, this._view.getWaveformData(), frameOffset, this._segment ? this._view.timeToPixels(this._segment.startTime) : frameOffset, this._segment ? this._view.timeToPixels(this._segment.endTime) : frameOffset + width, width, height);
    };
    WaveformShape.prototype._drawWaveform = function (context, waveformData, frameOffset, startPixels, endPixels, width, height) {
        if (startPixels < frameOffset) {
            startPixels = frameOffset;
        }
        var limit = frameOffset + width;
        if (endPixels > limit) {
            endPixels = limit;
        }
        if (endPixels > waveformData.length) {
            endPixels = waveformData.length;
        }
        var channels = waveformData.channels;
        var waveformTop = 0;
        var waveformHeight = Math.floor(height / channels);
        for (var i = 0; i < channels; i++) {
            if (i === channels - 1) {
                waveformHeight = height - (channels - 1) * waveformHeight;
            }
            this._drawChannel(context, waveformData.channel(i), frameOffset, startPixels, endPixels, waveformTop, waveformHeight);
            waveformTop += waveformHeight;
        }
    };
    WaveformShape.prototype._drawChannel = function (context, channel, frameOffset, startPixels, endPixels, top, height) {
        var x, val;
        var amplitudeScale = this._view.getAmplitudeScale();
        context.beginPath();
        for (x = startPixels; x < endPixels; x++) {
            val = channel.min_sample(x);
            context.lineTo(x - frameOffset + 0.5, top + scaleY(val, height, amplitudeScale) + 0.5);
        }
        for (x = endPixels - 1; x >= startPixels; x--) {
            val = channel.max_sample(x);
            context.lineTo(x - frameOffset + 0.5, top + scaleY(val, height, amplitudeScale) + 0.5);
        }
        context.closePath();
        context.fillShape(this);
    };
    return WaveformShape;
}(require('peaks/waveform/waveform.utils'), require('konva'));